export default {
  NODE_ENV: 'production',
  ENDPOINTS: {
    NEST_BACKEND: 'https://qamaterialsapi.ulinksolution.com',
    CAT4MRO_WS: 'wss://backend-dev.cat4mro.com/v1/graphql',
    CAT4MRO_HTTP: 'https://backend-dev.cat4mro.com/v1/graphql',
    CAT4MRO_SECRET: '7iH76a1uzYE328vs0lxqEYGer',
    CAT4MRO_APIHTTP: 'https://qamrocatalogupload.azurewebsites.net',
    CAT4MRO_SITE: 'https://qa.cat4mro.com'
  },
  IDENTITY: {
    AUTHORITY: 'https://qa-identityadminsts.ulinksolution.com',
    REDIRECT_URI: 'https://qa-admintest.ulinksolution.com/static/callback.html',
    SILENT_REDIRECT_URI: 'https://qa-admintest.ulinksolution.com/static/silent-renew.html',
    POST_LOGOUT_REDIRECT_URI: 'https://qa-admintest.ulinksolution.com'
  }
}



// WEBPACK FOOTER //
// ./src/config/env.production.js